import { DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FormGroup, UntypedFormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { from, map } from 'rxjs';
import Swal from 'sweetalert2';
import { AlertService } from './alert.service';


@Injectable({ 
    providedIn: 'root'
})

// THE FUNCTION DEFINED HERE IN THESE CAN BE TRIGGERED INDEFINITELY IF ADDED AS {{ fncCall() }} SO MAKE SURE TO PUSH THEM TO HELPER PIPE IF ANY FUNCTION GETS USED MORE OFTEN TO REDUCE LOAD ON CLIENT SIDE FOR PROCESSING

export class HelperService {

    formButtonDisabled: boolean = false;

    constructor(
        private translate: TranslateService,
        private datePipe: DatePipe,
        private http: HttpClient,
        private translateService: TranslateService,
        private alertService: AlertService
    ){}

    actionConfirmation(msg="", confirmBtnClass="btn btn-danger") {

        const set_msg = msg !== "" ? msg : 'ALERTS.perform-action'; 
        return Swal.fire({
            title: this.translate.instant('COMMON.confirmation'),
            html: `
                <div class='swal-customs-div'>
                    <h5 class='swal-custom-title'>${this.translate.instant('COMMON.are-you-sure')}</h5>
                    <p class='swal-custom-text'>${this.translate.instant(set_msg)}</p>
                </div>`,
            // text: this.translate.instant('COMMON.are-you-sure') + "<br>" + this.translate.instant(set_msg),
            showCancelButton: true,
            cancelButtonText: `${this.translate.instant('COMMON.close')}`,
            confirmButtonText: this.translate.instant('COMMON.proceed'),
            customClass: {
                confirmButton: confirmBtnClass,
                cancelButton: 'cancel-swal-custom btn btn-secondary'
            },
        }).then(result => {
            return result.isConfirmed;
        });
    }

    deleteRecord(): Promise<boolean> {
        return Swal.fire({
          title: this.translate.instant('COMMON.confirmation'),
          html: `
            <div class='swal-customs-div'>
                <h5 class='swal-custom-title'>${this.translate.instant('COMMON.are-you-sure')}</h5>
                <p class='swal-custom-text'>${this.translate.instant('COMMON.wont-recover')}</p>
            </div>`,
          showCancelButton: true,
          customClass: {
            confirmButton: 'btn btn-danger',
            cancelButton: 'cancel-swal-custom btn btn-secondary'
          },
          cancelButtonText: `${this.translate.instant('COMMON.close')}`,
          confirmButtonText: this.translate.instant('COMMON.yes-delete')
        }).then(result => {
          return result.isConfirmed;  // Return true if confirmed, false otherwise
        });
    }

    createFormData(formElement: FormGroup | UntypedFormGroup){
        const formData = new FormData();
        Object.keys(formElement.controls).forEach(field => {
            formData.append(field, (formElement.get(field)?.value ?? "") );
        });

        return formData;
    }

    validateAvatar(event){
        const input = event.target as HTMLInputElement;
    
        if (input.files && input.files[0]) {
          const file = input.files[0];
          const maxSizeInMB = 3;
    
          // Validate file type
          const allowedTypes = ['image/png', 'image/jpeg', 'image/jpg'];
          if (!allowedTypes.includes(file.type)) {
            return [false, this.translate.instant('VALIDATION.avatar-type')];
          }
    
          // Validate file size
          if (file.size > maxSizeInMB * 1024 * 1024) {
            return [false, this.translate.instant('VALIDATION.avatar-size')];
          }

          return [true, file];

        }

        return [false, ""];
    }

    formatNumberNL(value: number | string | null | undefined): string {
        if (!value || isNaN(+value)) {
            return '0';
        }
    
        const number = Number(value);
        const hasFraction = number % 1 !== 0;

        const options: Intl.NumberFormatOptions = {
            minimumFractionDigits: hasFraction ? 2 : 0,
            maximumFractionDigits: 2,
            useGrouping: true
        };
    
        return new Intl.NumberFormat('nl-NL', options).format(number);
    }

    percentageAmount(amount: number | string | null | undefined, percentage: number | string | null | undefined){
        if (!amount || isNaN(+amount) || !percentage || isNaN(+percentage)) {
            return '0,00';
        }

        var result: any = (+amount / 100) * (+percentage);
        return this.formatNumberNL(result);
    }

    commaSeperatedString(array: string[]) : string {
        if (!Array.isArray(array)) return '-';
        const data = array
                        .map(item => (item ? item.trim() : ''))     // remove whitespace
                        .filter(item => item !== '')  // remove empty values
                        .join(', ')
                        .trim();

        return (data == "" ? "" : data);
    }

    clubTags: string[] = [
        "<club>",
        "<club-straat>",
        "<club-postcode>",
        "<club-plaats>",
        "<club-logo-url>"
    ];
      
    memberTags: string[] = [
        "<naam-lid>",
        "<voornaam-lid>",
        "<lidnummer>", 
        "<lid-straat>",
        "<lid-postcode>",
        "<lid-plaats>",
        "<lid-land>",
        "<e-mail>",
        "<telefoonnummer>"
    ];
    
    dossierTags: string[] = [
        "<dossier-id>",
        "<seizoen>",
        "<team>",
        "<totaal>",
        "<al-betaald>",
        "<openstaand-bedrag>",
        "<brief-datum>"
    ];

    workflowTags: string[] = [
        "<betaallink>",
        "<openstaand-bedrag-factuur>",
    ];

    workflowOtherTags: string[] = [
        "<totaal-aantal-termijnen>",
        "<workflow-startdatum>",
        "<termijnbetaling>",
        "<servicekosten>",
        "<totaal-eerste-termijn>",
        "<termijn>",
        "<dossierdetail-link>",
        "<incassokosten>"
    ]

    workflowOnlyTags: string[] = [
        
    ]

    creatingExport: boolean = false;
    generateExport(downloadUrl, fileTitle, prependTitle=""){

        if(this.creatingExport === false){
            
            this.creatingExport = true;
            this.http.get(downloadUrl, {
                responseType: 'blob',
                withCredentials: true // if you're using Sanctum or cookies
            }).subscribe(blob => {
                const fileName = prependTitle + this.translateService.instant(fileTitle)+'.xlsx';
                const a = document.createElement('a');
                const objectUrl = URL.createObjectURL(blob);
                a.href = objectUrl;
                a.download = fileName;
                a.click();
                URL.revokeObjectURL(objectUrl); // cleanup
                this.creatingExport = false;
            }, error => {
                const msg = this.translateService.instant("ALERTS.failed-to-download-no-exist");
                this.alertService.triggerAlert(msg, "error");   
                this.creatingExport = false;
            });
        }
        

    }

    getSmaller(firstNum: number, secondNum: number){
        if(!firstNum)
            return secondNum;
        
        if(!secondNum)
            return firstNum;

        return (+firstNum < +secondNum) ? firstNum : secondNum;
    }

    getDaysFromToday(dateStr: string | null | undefined): number {

        if (!dateStr) return 0;

        // Normalize: turn "2025-03-01 14:30:00" → "2025-03-01T14:30:00"
        // And "2025-03-01" stays "2025-03-01"
        const normalized = dateStr.replace(' ', 'T');

        // Create JS Date (local timezone, no UTC conversion)
        const target = new Date(normalized);

        // Strip time from "today"
        const now = new Date();
        const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());

        // Strip time if input had time part
        const targetMidnight = new Date(target.getFullYear(), target.getMonth(), target.getDate());

        const diffMs = today.getTime() - targetMidnight.getTime();
        var days = Math.round(diffMs / (1000 * 60 * 60 * 24));

        return days + 1;
    }

    getEmailBody(){
        return `<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">
                <html xmlns="http://www.w3.org/1999/xhtml" xmlns:v="urn:schemas-microsoft-com:vml" xmlns:o="urn:schemas-microsoft-com:office:office">
                <head>
                    
                    <meta http-equiv="Content-type" content="text/html; charset=utf-8" />
                    <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1" />
                    <meta http-equiv="X-UA-Compatible" content="IE=edge" />
                    <meta name="format-detection" content="date=no" />
                    <meta name="format-detection" content="address=no" />
                    <meta name="format-detection" content="telephone=no" />
                    <meta name="x-apple-disable-message-reformatting" />
                    

                    <style type="text/css" media="screen">
                        body { padding:0 !important; margin:0 !important; display:block !important; min-width:100% !important; width:100% !important; background:#edf2f7; -webkit-text-size-adjust:none }
                        a { color:#000000; text-decoration:none }
                        /* p { padding:0 !important; margin:0 !important }  */
                        img { -ms-interpolation-mode: bicubic; /* Allow smoother rendering of resized image in Internet Explorer */ }
                        .PreviewText { display: none !important; }
                        @media only screen and (max-device-width: 480px), only screen and (max-width: 480px) {
                            .mobile-shell { width: 100% !important; min-width: 100% !important; }
                            .bg { background-size: 100% auto !important; -webkit-background-size: 100% auto !important; }
                            .center { margin: 0 auto !important; }
                            .container { padding: 10px !important; padding-top: 20px !important; }
                            .pdb20 { padding-bottom: 20px !important; }
                            .td { width: 100% !important; min-width: 100% !important; }
                            .p40-20 { padding: 40px 20px !important; }
                            .p40 { padding: 20px !important; }
                        }

                    a:-webkit-any-link, .ii a[href], a, .ii a[href] {
                            text-decoration: none !important;
                            color: #f3834d !important;
                            font-size: 16px !important;
                        }
                    a.email-link {
                        text-decoration: underline !important;
                        color: #f3834d !important;
                    } 
                    a.btn-nikki, a:-webkit-any-link.btn-nikki, .ii a[href].btn-nikki, .ii a[href].btn-nikki,
                    a#btn-nikki, a:-webkit-any-link#btn-nikki, .ii a[href]#btn-nikki, .ii a[href]#btn-nikki {
                            background-color: #f3834d !important;
                            color: hsl(0, 0%, 100%) !important;
                            padding: 5px !important;
                            border: unset !important;
                            border-radius: 0.25rem !important;
                            padding-top: 0.5rem !important;
                            padding-bottom: 0.5rem !important;
                            padding-left: 0.9rem !important;
                            padding-right: 0.9rem !important;
                            display: inline-block !important;
                        }
                    </style>
                </head>
                <body class="body" style="padding:0 !important; margin:0 !important; display:block !important; min-width:100% !important; width:100% !important; background:#edf2f7; -webkit-text-size-adjust:none;">
                    <table width="100%" border="0" cellspacing="0" cellpadding="0" bgcolor="#edf2f7">
                        <tr>
                            <td align="center" valign="top">
                                <table width="602" border="0" cellspacing="0" cellpadding="0" class="mobile-shell">
                                    <tr>
                                        <td class="td container" style="width:602px; min-width:602px; font-size:0pt; line-height:0pt; margin:0; font-weight:normal; padding:25px 0px;">

                                            <table width="100%" border="0" cellspacing="0" cellpadding="0">
                                                <tr>
                                                    <td class="pdb20" style="font-size:0pt; line-height:0pt; text-align:center; max-width: 73px; padding-bottom: 25px;">
                                                    <a href="#" target="_blank">
                                                        <img src="https://api.nikki.nl//logo-email.png" width="73" height="70" style="max-width: 73px; height: 70px; width: 100%;" border="0" alt="NIKKI" />
                                                    </a>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="p40-20" style="padding: 40px 30px; border: 1px solid #f4f4f4; background-color: #ffffff;" bgcolor="#ffffff">
                                                        <table width="100%" border="0" cellspacing="0" cellpadding="0">
                                                            <tr>
                                                            <td style="font-family:-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'; font-size:16px; line-height:24px; color:#000000; text-align:left; padding-bottom:16px;">
                                                                <bodycontent>
                                                            </td>
                                                            </tr>
                                                        </table>
                                                    </td>
                                                </tr>
                                        <tr>
                                        <td style="font-family:-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'; font-size:16px; line-height:24px; color:#000000; text-align:center; padding-top:20px;">
                                                © <currentyear> NIKKI.
                                        </td>
                                        </tr>
                                            </table>
                                        </td>
                                    </tr>
                                </table>
                            </td>
                        </tr>
                    </table>
                </body>
                </html>`
    }

    replacePreviewTags(html: string, textarea: boolean = true, isEmail: boolean = false) {

        let result = html ?? "";
        result = result.replace(/&lt;/g, "<");
        result = result.replace(/&gt;/g, ">");

        let emailBody = this.getEmailBody();
        if(isEmail){
            let oldResult = result;
            const year = new Date().getFullYear();

            result = emailBody;
            result = result.replace(/<bodycontent>/g, oldResult);
            result = result.replace(/<currentyear>/g, year.toString());
        }

        const replacements: Record<string, string> = {
            "&lt;": "<",
            "&gt;": ">",
            "<club>": "Clubnaam",
            "<club-straat>": "Straatnaam-club",
            "<club-postcode>": "1822 JP",
            "<club-plaats>": "Amsterdam",
            "<club-logo-url>": "https://api.nikki.nl/logo-email.png",

            "<naam-lid>": "de Vries",
            "<voornaam-lid>": "Jan",
            "<lidnummer>": "12345",
            "<lid-straat>": "Teststraat 22",
            "<lid-postcode>": "2218 BS",
            "<lid-plaats>": "Amsterdam",
            "<lid-land>": "Nederland",

            "<e-mail>": "jan.devries@test.nl",
            "<telefoonnummer>": "0612345678",

            "<dossier-id>": "12345",
            "<seizoen>": "2026",
            "<team>": "H1",

            "<totaal>": "522",
            "<al-betaald>": "120",
            "<openstaand-bedrag>": "402",

            "<brief-datum>": "13-03-2026",
            "<betaallink>": "https://betaallink.nikki.nl",

            "<openstaand-bedrag-factuur>": "258",
            "<totaal-aantal-termijnen>": "6",

            "<workflow-startdatum>": "10-03-2026",

            "<termijnbetaling>": "43",
            "<servicekosten>": "19",
            "<totaal-eerste-termijn>": "62",
            "<termijn>": "1",
            "<dossierdetail-link>": "https://dossierdetail-link.nikki.nl",
            "<incassokosten>": "105",

            "<voornaam>": "Jan",
            "<factuurdatum-en-tijd>": "10-03-2026 12:22",
            "<bedrag>": "62",
            "<betaalmethode>": "Openstaande betaling",
            "<betaald-aan>": "NIKKI",
        };

        if(textarea)
            result = result.replace(/\n/g, "<br>");
        
        Object.keys(replacements).forEach(tag => {
            const regex = new RegExp(tag.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'g');
            result = result.replace(regex, replacements[tag]);
        });

        

        return result;

    }
}

